import { CatalogOperatorsPage } from "./CatalogOperatorPage";

import { Route, Routes } from "react-router-dom";
import { CatalogOperatorProvider } from "./context/CatalogOperatorContext";

type Props = {};
const CatalogOperator = (props: Props) => {
  return (
    <CatalogOperatorProvider>
      <Routes>
        <Route index element={<CatalogOperatorsPage />}></Route>
        <Route path=":operatorId" element={<CatalogOperatorsPage />}></Route>
      </Routes>
    </CatalogOperatorProvider>
  );
};
export default CatalogOperator;
